import { Theme } from '@mui/material';

export function iconButton({ palette }: Theme) {
  const largeSize = 56;
  const mediumSize = 44;
  const smallSize = 25;

  const commonBorder = '1px solid #EAECF0';
  const commonBoxShadow = '0px 1.222px 2.444px 0px rgba(16, 24, 40, 0.05)';

  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          border: commonBorder,
          boxShadow: commonBoxShadow,
          color: palette.grey[900],
          backgroundColor: palette.common.white,
          '&:hover': {
            backgroundColor: palette.action.hover,
          },
          '&.Mui-disabled': {
            color: palette.grey[500],
          },
          '&:hover, &.active': {
            color: palette.grey[900],
            opacity: 1,
          },
          '& .MuiTouchRipple-root .MuiTouchRipple-child': {
            borderRadius: '8px',
          },
        },
        sizeLarge: {
          width: largeSize,
          height: largeSize,

          '& .MuiTouchRipple-root .MuiTouchRipple-child': {
            width: largeSize,
            height: largeSize,
          },
        },
        sizeMedium: {
          width: 44,
          height: 44,

          '& .MuiTouchRipple-root .MuiTouchRipple-child': {
            width: mediumSize,
            height: mediumSize,
          },

          '&.responsive': {
            '@media (max-width: 767px)': {
              width: 34,
              height: 34,

              '& .MuiTouchRipple-root .MuiTouchRipple-child': {
                width: 34,
                height: 34,
              },
            },
          },
        },
        sizeSmall: {
          width: 25,
          height: 25,

          '& .MuiTouchRipple-root .MuiTouchRipple-child': {
            width: smallSize,
            height: smallSize,
          },
        },
      },
    },
  };
}
